import axios from 'axios';
import downloadFile, { FileType } from '../utils/downloadFile';
import getFilename from '../utils/getFilename';
import { throwWrappedAxiosError } from 'lib/errors';
import { SelfServiceAPI } from 'types';

const downloadInvoicePdf = async (booking: SelfServiceAPI.Booking) => {
  await axios({
    method: 'get',
    url: booking.links.downloadInvoice,
    responseType: 'blob',
    withCredentials: true,
  })
    .then(({ headers, data }) => {
      const filename = getFilename(headers);
      downloadFile(filename || `tax-invoice-${booking.reference}.pdf`, data, FileType['application/pdf']);
    })
    .catch(throwWrappedAxiosError);
};

export default downloadInvoicePdf;
